import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';

import * as officeLocationAPI from 'api/officeLocation';

const initialState = {
    list: {
        error: false,
        loaded: false,
        data: []
    },
    patientAssignableOfficeLocations: {
        error: false,
        loaded: false,
        data: []
    }
};

const slice = createSlice({
    name: 'officeLocation',
    initialState,
    reducers: {
        setOfficeLocationsError(state) {
            state.list.error = true;
            state.list.loaded = true;
        },
        setOfficeLocations(state, action) {
            state.list.error = false;
            state.list.loaded = true;
            state.list.data = action.payload;
        },
        resetOfficeLocations(state) {
            state.list = initialState.list;
        },
        setPatientAssignableOfficeLocationsError(state) {
            state.patientAssignableOfficeLocations.error = true;
            state.patientAssignableOfficeLocations.loaded = true;
        },
        setPatientAssignableOfficeLocations(state, action) {
            state.patientAssignableOfficeLocations.error = false;
            state.patientAssignableOfficeLocations.loaded = true;
            state.patientAssignableOfficeLocations.data = action.payload;
        },
        resetPatientAssignableOfficeLocations(state) {
            state.patientAssignableOfficeLocations = initialState.patientAssignableOfficeLocations;
        }
    }
});

export default slice.reducer;

export function resetOfficeLocations() {
    dispatch(slice.actions.resetOfficeLocations());
}

export function getOfficeLocations() {
    return async () => {
        try {
            const response = await officeLocationAPI.getOfficeLocations();
            dispatch(slice.actions.setOfficeLocations(response.data.officeLocations || []));
        } catch (error) {
            dispatch(slice.actions.setOfficeLocationsError(error));
        }
    };
}

export function resetPatientAssignableOfficeLocations() {
    dispatch(slice.actions.resetPatientAssignableOfficeLocations());
}

export function getPatientAssignableOfficeLocations() {
    return async () => {
        try {
            const response = await officeLocationAPI.getPatientAssignableOfficeLocations();
            dispatch(slice.actions.setPatientAssignableOfficeLocations(response.data.officeLocations || []));
        } catch (error) {
            dispatch(slice.actions.setPatientAssignableOfficeLocationsError(error));
        }
    };
}
